import { createSlice } from '@reduxjs/toolkit';
import { approveSelectedArea, getInteractiblePlantsForBees } from '../area';
import { beeSelectionMethodsEnum } from './types';
import {
  makeSelectDenormEntity,
  makeSelectEntityWithIsSelected,
} from '../../utils/reselectFactories';
import { restartSession } from '../session';

const initialState = {
  beesById: null,
  ids: [],
  interactiblePlantsByBeeId: null,
  selectedBeeIds: [],
  selectionMethod: null,
};

export const bees = createSlice({
  name: 'bees',
  initialState,
  reducers: {
    setSelectionMethod: (state, action) => {
      state.selectionMethod = action.payload;
    },
    setSelectedBeeIds: (state, action) => {
      state.selectedBeeIds = action.payload;
    },
    setSelectedBeesBasedOnSelectionMethod: (state) => {
      if (!state.selectionMethod) {
        return;
      }

      switch (state.selectionMethod) {
        // todo: If you click "manual", select bees and then reclick "manual"
        // the selected bees reset. We could fix this by not resetting the
        // selectedBeeIds if the selectionMethod was already "manual"
        case beeSelectionMethodsEnum.manual:
          state.selectedBeeIds = [];
          break;
        case beeSelectionMethodsEnum.redList:
          state.selectedBeeIds = state.ids
            .reduce((acc, id) => {
              const bee = state.beesById[id];

              return bee.isRedList
                ? [...acc, bee.id]
                : acc;
            }, []);
          break;
        case beeSelectionMethodsEnum.all:
          state.selectedBeeIds = state.ids;
          break;
        default:
          break;
      }
    },
    addSelectedBeeId: (state, action) => {
      state.selectedBeeIds.push(action.payload);
    },
    addSelectedBeeIds: (state, action) => {
      state.selectedBeeIds = [...new Set([...state.selectedBeeIds, ...action.payload])];
    },
    removeSelectedBeeId: (state, action) => {
      state.selectedBeeIds = state.selectedBeeIds.filter((id) => id !== action.payload);
    },
  },
  extraReducers: {
    [restartSession.fulfilled]: () => initialState,
    [approveSelectedArea.fulfilled]: (state, action) => {
      const {
        beesById,
        beeIds,
      } = action.payload;

      state.beesById = beesById;
      state.ids = beeIds;
      state.selectedBeeIds = [];
    },
    [getInteractiblePlantsForBees.fulfilled]: (state, action) => {
      const {
        interactiblePlantsByBeeId,
      } = action.payload;

      state.interactiblePlantsByBeeId = interactiblePlantsByBeeId;
    },
  },
});

export const {
  setSelectedBeeIds,
  addSelectedBeeIds,
  addSelectedBeeId,
  removeSelectedBeeId,
  setSelectedBeesBasedOnSelectionMethod,
  setSelectionMethod,
} = bees.actions;

/* eslint-disable max-len */
export const selectInteractibleplantsByBeeId = (state) => state.bees.interactiblePlantsByBeeId;

export const selectBeesById = (state) => state.bees.beesById;
export const selectIds = (state) => state.bees.ids;
export const selectSelectionMethod = (state) => state.bees.selectionMethod;
export const selectSelectedBeeIds = (state) => state.bees.selectedBeeIds;

export const selectDenormBees = makeSelectDenormEntity(selectBeesById, selectIds);
export const selectBeesWithIsSelected = makeSelectEntityWithIsSelected(selectDenormBees, selectSelectedBeeIds);
/* eslint-enable max-len */

export default bees.reducer;
